import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CalendarCheck } from "lucide-react";
import { SECTIONS, sectionTag, sectionLabel } from "@/lib/sections";

export function AttendanceControls({ section, onSection, meetingDate, onDate, onAll, onSave }) {
  return (
    <Card className="card-shadow-soft">
      <CardContent className="p-5 grid grid-cols-1 md:grid-cols-4 gap-3 items-end">
        <div className="space-y-1.5">
          <Label>Section</Label>
          <Select value={section} onValueChange={onSection}>
            <SelectTrigger data-testid="att-section" className="min-h-[44px]"><SelectValue /></SelectTrigger>
            <SelectContent>
              {SECTIONS.map((s) => <SelectItem key={s.value} value={s.value}>{s.label}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-1.5">
          <Label>Meeting date</Label>
          <Input type="date" data-testid="att-date" value={meetingDate} onChange={(e) => onDate(e.target.value)} className="min-h-[44px]" />
        </div>
        <div className="md:col-span-2 flex flex-wrap gap-2 md:justify-end">
          <Button variant="outline" onClick={() => onAll("present")} data-testid="all-present">Mark all present</Button>
          <Button variant="outline" onClick={() => onAll("absent")} data-testid="all-absent">Mark all absent</Button>
          <Button onClick={onSave} data-testid="save-attendance"><CalendarCheck className="w-4 h-4 mr-1.5" />Save register</Button>
        </div>
      </CardContent>
    </Card>
  );
}

export function AttendanceSummary({ section, summary }) {
  return (
    <div className="flex flex-wrap items-center gap-3 text-sm">
      <span className={`scout-tag ${sectionTag(section)}`}>{sectionLabel(section)}</span>
      <span className="text-muted-foreground">{summary.present} / {summary.total} present · <span className="font-semibold text-foreground">{summary.pct}%</span></span>
      <div className="flex-1 max-w-xs bg-secondary rounded-full h-2 overflow-hidden">
        <div className="h-full bg-primary transition-all" style={{ width: `${summary.pct}%` }} />
      </div>
    </div>
  );
}

const pct = (p, total) => (total ? Math.round((p / total) * 100) : 0);

export function RecentRegisters({ section, history }) {
  if (!history.length) return null;
  return (
    <Card className="card-shadow-soft">
      <CardContent className="p-5">
        <h2 className="font-bold text-lg mb-3" style={{ fontFamily: "Outfit" }}>Recent registers · {sectionLabel(section)}</h2>
        <div className="space-y-2">
          {history.slice(0, 8).map((h) => {
            const records = h.records || [];
            const p = records.filter((r) => r.status === "present").length;
            return (
              <div key={h.id} className="flex items-center justify-between text-sm border-b border-border last:border-b-0 py-2" data-testid={`history-${h.id}`}>
                <div className="font-medium">{h.meeting_date}</div>
                <div className="text-muted-foreground">{p}/{records.length} present · {pct(p, records.length)}%</div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
